import { Inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { Environment } from '../../../app/types/environment.interface';
import { ENVIRONMENT } from '../../core';
import {
  AddressAPI,
  AddressAPIOptionalParams,
  AddressRetrieveResponse,
  AddressSearchDrillDownResponse,
  AddressSearchOperationResponse,
} from '../client/src';
import { AddHeadersRequestPolicy } from '../util';

@Injectable({
  providedIn: 'root',
})
export class AddressesService {
  protected readonly baseApi: AddressAPI;

  constructor(@Inject(ENVIRONMENT) private env: Environment) {
    const clientParams: AddressAPIOptionalParams = {
      endpoint: `${env.nxApi.base}/${env.nxApi.fragment.address}`,
      additionalPolicies: [
        { policy: new AddHeadersRequestPolicy(), position: 'perCall' },
      ],
    };

    this.baseApi = new AddressAPI(clientParams);
  }

  public search(
    query: string,
    sessionId: string | undefined
  ): Observable<AddressSearchOperationResponse> {
    return from(
      this.baseApi.addressSearch({
        body: { searchText: query, session: sessionId },
      })
    );
  }

  public drillDown(value: string): Observable<AddressSearchDrillDownResponse> {
    return from(this.baseApi.addressSearchDrillDown({ body: { value } }));
  }

  public retrieveAddress(value: string): Observable<AddressRetrieveResponse> {
    return from(this.baseApi.addressRetrieve({ body: { value } }));
  }
}
